module.exports = __webpack_public_path__ + "img/banner-pic.38da7ac.png";